module.exports = __webpack_public_path__ + "static/img/female-bg-fr.5b8be1bd.png";